import get from 'lodash/get'
import { i18n } from '../index'
const ALL_EMPLOYEES = ''
type EmployeeData = {
  node: {
    id: string
    user: {
      id: string
      name: string
    }
  }
}
type EmployeeOptionValueType = 'userId' | 'employeeId'
export const getEmployeeSelectorOptions = (
  employees: Array<EmployeeData>,
  valueType: EmployeeOptionValueType = 'employeeId',
): Array<{ label: string; value: string }> => {
  const optionValueGetter = valueType === 'userId' ? 'node.user.id' : 'node.id'
  const options = [
    {
      label: i18n.t('reporting.allEmployees') as string,
      value: ALL_EMPLOYEES,
    },
    ...employees.map((employee) => ({
      label: get(employee, 'node.user.name', ''),
      value: get(employee, optionValueGetter, ''),
    })),
  ]
  return options
}

export const getProductSelectorOptions = (
  products: Array<{ name: string; price: number; id?: string }>,
): Array<{ label: string; value: string | undefined | null }> => {
  const options = [
    {
      label: i18n.t('reporting.allProducts') as string,
      value: undefined,
    },
    ...products.map(({ name, price, id }) => ({
      label: id ? `${name}, ${price} €` : (i18n.t('reporting.noProduct') as string),
      value: id || null,
    })),
  ]
  return options
}

export const getThumbsUpSelectorOptions = (
  products: Array<{ name: string; price: number; id?: string }>,
): Array<{ label: string; value: string | undefined }> => {
  return [
    {
      label: i18n.t('reporting.allServices') as string,
      value: undefined,
    },
    ...products.map(({ name, id }) => ({
      label: name,
      value: id,
    })),
  ]
}
